import APP_CONFIG from "../configs/environment";

export const FederatedEngageAIProvider: any = APP_CONFIG.appSettingsData.federatedEngageAIProvider;
